import { isUndefined } from 'lodash'
import { isEmpty, isObject } from 'lodash/fp'
import { getInvalidFieldLabel } from 'utils/validation/helpers'

export const getInvalidText = ({ conditions, invalid, tInvalid }) => {
  if (!isUndefined(conditions) && invalid) {
    const { invalidText } = conditions.find(
      (rule) => !isUndefined(rule.invalidText)
    )
    return getInvalidFieldLabel(tInvalid, invalidText)
  }

  return ''
}

export const getFilterObjectValue = ({ element, formValues, filterKey }) => {
  // An element witohut % is not connected to a form value, hence it is returned
  if (!element.includes('%')) return element

  // Remove the % symbol from the string
  const elementSliced = element.slice(1)
  const value = formValues[elementSliced]

  // If the element is an object, returns its filterKey (if not specified, it's value)
  return isObject(value) ? value[filterKey] : value
}

export const getQueryString = (obj) => {
  if (isEmpty(obj)) {
    return null
  }

  return new URLSearchParams(obj).toString()
}

export const getOptionLabel = (t, key) => {
  const strictLabel = t(key)
  if (strictLabel === key) {
    const platformLabel = t(`OptionsPlatform:${key}`)
    return platformLabel === key ? t(`Options:${key}`) : platformLabel
  } else return strictLabel
}
